export class FormBuilderSectionPermissionModel {
    public tag: string;

    public permission: string;

    constructor(tag: string, permission: string) {
        this.tag = tag;

        this.permission = permission;
    }
}
